import { useWoody } from '../../woody/woody.js';
import { useMutation } from '@tanstack/react-query';
import { useQueryCacheShareTokenHelpers } from '../queries/useQueryCacheShareTokenHelpers.js';

const useMutationShareTokenUpdate = () => {
  const { client } = useWoody();
  const { updateTokenRole } = useQueryCacheShareTokenHelpers();
  return useMutation({
    mutationFn: async ({ resourceId, shareTokenId, role }) => {
      return client.v2({
        endpoint: "/v2/resources/{resourceId}/share-token/{shareTokenId}",
        params: {
          resourceId,
          shareTokenId
        }
      }, {
        method: "patch",
        body: {
          role
        }
      });
    },
    onMutate: (variables) => {
      return updateTokenRole(variables);
    },
    onError: (error, variables, context) => {
      context?.resetCacheToPreOptimisticState();
    },
    onSettled: (data, error, variables, context) => {
      context?.invalidateQueries();
    }
  });
};

export { useMutationShareTokenUpdate };
//# sourceMappingURL=useMutationShareTokenUpdate.js.map
